import { type ConfigUrls } from 'hb-react/frontoffice/apps/Forum/types';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import {
  type CategoriesReturn,
  type DiscussionRequest,
  type DiscussionReturn,
  type DiscussionsReturn,
  type CreateDiscussionRequest,
  type FollowDiscussionRequest,
  type UpdateDiscussionRequest,
  type WidgetReturn,
} from './requests.types';

export const getTransformCategories = (configUrls: ConfigUrls) =>
  axios.get<CategoriesReturn>(configUrls.getCategoriesPath()).then(({ data }) =>
    data.categories?.map((c) => ({
      name: `cat_${c.id}`,
      label: c.name,
      query: {
        [`cat_${c.id}`]: c.id,
      },
    })),
  );

export const getCategories = (
  configUrls: Pick<ConfigUrls, 'getCategoriesPath'>,
) =>
  axios
    .get<CategoriesReturn>(configUrls.getCategoriesPath())
    .then(({ data }) => data.categories);

export const getDiscussion = ({
  configUrls,
  discussionId,
}: DiscussionRequest) =>
  axios
    .get<DiscussionReturn>(configUrls.getDiscussionPath(discussionId))
    .then(({ data }) => data.discussion);

export const getEditDiscussion = ({
  configUrls,
  discussionId,
}: DiscussionRequest) =>
  axios
    .get<DiscussionReturn>(configUrls.getEditDiscussionPath(discussionId))
    .then(({ data }) => data.discussion);

export const getDiscussions = ({ configUrls, params = {}, signal }) =>
  axios
    .get<DiscussionsReturn>(configUrls.getDiscussionsPath(), {
      params,
      signal,
    })
    .then(({ data }) => ({
      items: data.discussions,
      totalItems: data.pagination.total_items,
    }));

export const deleteDiscussion = ({
  configUrls,
  discussionId,
}: DiscussionRequest) =>
  axios
    .delete(configUrls.deleteDiscussionPath(discussionId))
    .then(({ data }) => data);

export const createDiscussion = ({
  configUrls,
  values,
}: CreateDiscussionRequest) =>
  axios
    .post<DiscussionReturn>(configUrls.createDiscussionPath(), {
      discussion: values,
    })
    .then(({ data }) => data.discussion);

export const updateDiscussion = ({
  configUrls,
  discussionId,
  values,
}: UpdateDiscussionRequest) =>
  axios
    .put<DiscussionReturn>(configUrls.updateDiscussionPath(discussionId), {
      discussion: values,
    })
    .then(({ data }) => data.discussion);

export const followDiscussion = ({
  configUrls,
  discussionId,
  follow,
}: FollowDiscussionRequest) =>
  axios
    .put<DiscussionReturn>(configUrls.followDiscussionPath(discussionId), {
      follow,
    })
    .then(({ data }) => data.discussion);

export const getWidgets = ({ configUrls }: { configUrls: ConfigUrls }) =>
  axios
    .get<WidgetReturn>(configUrls.getWidgetsPath())
    .then(({ data }) => data.top_categories);
